import * as React from "react";
const SvgFiRrOrganizationChart = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-organization-chart_svg__a)">
      <path
        fill="#062147"
        d="M1.5 17a2 2 0 1 1 4-.001 2 2 0 0 1-4 .001m8.5 0a2 2 0 1 0 4 .001A2 2 0 0 0 10 17m2-13a2 2 0 1 0 .001-3.999 2 2 0 0 0 0 3.999m6.5 13a2 2 0 1 0 4 .001 2 2 0 0 0-4-.001m-15-3a1 1 0 0 0 1-1 1 1 0 0 1 1-1H11v1a1 1 0 1 0 2 0v-1h5.5c.551 0 1 .448 1 1a1 1 0 0 0 2 0c0-1.654-1.346-3-3-3h-13c-1.654 0-3 1.346-3 3a1 1 0 0 0 1 1m8.5 6a3.51 3.51 0 0 0-3.43 2.801 1 1 0 0 0 1.96.399A1.5 1.5 0 0 1 12 22.001c.711 0 1.33.504 1.47 1.199a1 1 0 1 0 1.96-.399A3.51 3.51 0 0 0 12 20M9.351 8.979a1 1 0 0 0 1.18-.78A1.5 1.5 0 0 1 12 7c.71 0 1.328.504 1.47 1.199a1 1 0 1 0 1.96-.399A3.51 3.51 0 0 0 12 4.999 3.51 3.51 0 0 0 8.57 7.8a1 1 0 0 0 .78 1.179M3.451 20a3.51 3.51 0 0 0-3.43 2.801c-.11.542.24 1.069.78 1.18a1.006 1.006 0 0 0 1.18-.781 1.5 1.5 0 0 1 1.47-1.199c.71 0 1.328.504 1.47 1.199a1 1 0 1 0 1.96-.399A3.51 3.51 0 0 0 3.45 20m20.528 2.797C23.644 21.177 22.18 20 20.5 20s-3.144 1.177-3.479 2.797c-.112.541.235 1.07.776 1.183a1.007 1.007 0 0 0 1.182-.776c.145-.697.784-1.203 1.521-1.203s1.376.506 1.521 1.203a1 1 0 1 0 1.958-.407"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-organization-chart_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrOrganizationChart;
